import React from "react"
import { useInheritedTheme } from "../../hooks/use-theme"
import typographyStyles from "../../utils/typography-styles"
import SlateNode from "../slate-node"

const Paragraph = ({
  attributes,
  children,
  data = {},
  serializingFind,
  node
}) => {
  const { find: editingFind } = useInheritedTheme()
  const find = serializingFind || editingFind

  const style = {
    ...typographyStyles("paragraph", find),
    textAlign: data.alignment || find("paragraph", "textAlign")
  }

  return (
    <SlateNode as="p" node={node} {...attributes} style={style}>
      {children}
    </SlateNode>
  )
}

export default {
  component: Paragraph
}
